import { PageHeader } from "@/components/PageHeader";
import { LeadSection } from "@/components/LeadSection";
import { Section } from "@/components/kit";
import { Reveal } from "@/components/motion";
import { DuoBanner } from "@/components/DuoBanner";
import { Season2Route } from "@/components/Season2Route";
import { FormatDialogueSection } from "@/components/FormatDialogueSection";
import { Play, Calendar } from "lucide-react";
import { EPISODES, SCHEDULE, IMG } from "@/data/content";

export default function Episodios() {
  return (
    <>
      <PageHeader
        eyebrow="Episodios · Temporada 1"
        eyebrowColor="#A8E6CF"
        title={["Doce salidas.", "doce regresos."]}
        subtitle="En casa, cada quien puede contar qué llevaría en su maleta, qué probaría primero o a quién le gustaría preguntarle algo. La conversación siempre sigue."
      />

      <Section className="!pt-6">
        <div className="grid gap-5">
          {EPISODES.map((e, i) => {
            const isNow = e.statusType === "now";
            return (
              <Reveal key={e.n} delay={(i % 4) * 0.05}>
                <div className="group grid grid-cols-1 items-stretch overflow-hidden rounded-[2rem] bg-white shadow-[0_8px_30px_rgb(0,0,0,0.04)] sm:grid-cols-[260px_1fr]">
                  <div className="relative h-48 overflow-hidden sm:h-auto">
                    <img
                      src={e.img}
                      alt={e.city}
                      className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                    />
                    <span
                      className="absolute left-4 top-4 rounded-full px-3 py-1 font-mono text-[11px] font-bold uppercase tracking-widest text-ink"
                      style={{ backgroundColor: e.color }}
                    >
                      {e.code}
                    </span>
                  </div>
                  <div className="flex flex-col justify-between gap-4 p-6 sm:flex-row sm:items-center">
                    <div className="flex items-start gap-5">
                      <span className="font-display text-5xl font-extrabold tracking-tighter text-ink/15">
                        {e.n}
                      </span>
                      <div>
                        <h3 className="font-display text-2xl font-extrabold tracking-tight text-ink">
                          {e.city}
                        </h3>
                        <p
                          className="font-mono text-xs uppercase tracking-widest"
                          style={{ color: e.color }}
                        >
                          {e.title}
                        </p>
                        <p className="mt-2 max-w-md text-sm text-ink/60 leading-relaxed">
                          {e.blurb}
                        </p>
                      </div>
                    </div>
                    <div className="shrink-0">
                      {isNow ? (
                        <button
                          data-testid={`episode-play-${e.n}`}
                          className="group/btn inline-flex items-center gap-2 rounded-full bg-coral px-6 py-3 font-semibold text-white transition-all hover:-translate-y-0.5"
                        >
                          <Play className="h-4 w-4 fill-white" />
                          Ver ahora
                        </button>
                      ) : (
                        <span className="inline-flex items-center gap-2 rounded-full bg-mist px-5 py-3 font-mono text-xs uppercase tracking-widest text-ink/50">
                          <Calendar className="h-4 w-4" />
                          Próximo
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </Section>

      <DuoBanner
        image={IMG.duoEpisodes}
        imgSide="left"
        tint="#A8E6CF"
        eyebrowColor="#A8E6CF"
        title="Prepara las palomitas. El sábado es de Anto & Bella."
        text="La serie está pensada para compartirla: Ellas ponen la aventura; tú, el sillón favorito y la familia alrededor. Cada visita una aventura para las infancias, un detalle nuevo para los adultos y una conversación que puede seguir después de los créditos."
        cta={{ to: "/en-vivo", label: "Ver en vivo", variant: "coral" }}
      />

      <Season2Route />

      <FormatDialogueSection accent="#A8E6CF" eyebrow="Así se vive cada episodio" />

      <Section alt className="text-center">
        <Reveal>
          <p className="font-display text-3xl sm:text-4xl font-extrabold tracking-tighter text-ink">
            {SCHEDULE.main}
          </p>
          <p className="mt-2 font-mono text-sm uppercase tracking-widest text-ink/50">
            {SCHEDULE.region} · {SCHEDULE.replay}
          </p>
        </Reveal>
      </Section>
      <LeadSection path="/episodios" />
    </>
  );
}
